import React, { useState } from 'react'
import appSettings from '../../helpers/settings';

const About = props => {
  const [data] = useState({
    title: "Acerca de Nuestra App",
    intro: 'Podrás conocer el precio de cualquier artículo solamente escaneando el código de barras.',
    subtitle: appSettings.title,
    content: [
      "Diseñada de forma nativa para trabajar en dispositivos Android y iOS, nació desde la necesidad de brindar un nuevo servicio para nuestros clientes.",
      "Desde la comodidad de tu celular, se puede conocer el precio de un artículo en gondola solamente escaneando su código de barras.",
    ],
    features: [
      "Disponible en miles de dispositivos Android o iOS",
      "Diseño moderno y facil de usar",
    ],
    downloadBtn: {
      link: "#download",
      btnClass: "btn softo-solid-btn page-scroll",
      faClass: "fa fa-android",
      value: "Descargar"
    },
    image: '/img/phone6.png'
  });

  return (
    <section id="about" className="contact-us ptb-90">
      <div className="contact-us-wrap">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-heading">
                <h3 style={ { textAlign: 'center' } }>{ data.title }</h3>
                <p>{ data.intro }</p>
              </div>
            </div>
              <div className="col-md-7">
                <div className="footer-address">
                  <h6>{ data.subtitle }</h6>
                  { data.content.map((content, idx) => (<p key={ idx }>{ content }</p>)) }
                  <ul>
                    { data.features.map((feature, idx) => (<li key={ idx }><i className="fa fa-check"></i> <span>{ feature }</span></li>)) }
                  </ul>
                  <a 
                    style={ { marginTop: 16 } }
                    className={ data.downloadBtn.btnClass }
                    href={ data.downloadBtn.link } > 
                    <i className={ data.downloadBtn.faClass }></i> { data.downloadBtn.value }
                  </a>
                </div>
              </div>
              <div className="col-md-5">
                <img alt="about" src={ data.image } style={ { height: 400 } } />
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}
export default About